import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/shared/config';
import { Card, PageLayout, Skeleton } from '@/shared/ui';

/**
 * Экран, пока грузится чанк страницы (`lazyPage` в `app/router`): шапка,
 * заголовок раздела и тот же скелет тем, что
 * `MistakesPage` показывает при первой загрузке, — загрузка кода и данных
 * идёт одним шиммером. Классы карточки — те же, что у обзора в `MistakesPage`
 * (почему именно такие отступы — см. комментарий там).
 */
export function MistakesPageSkeleton() {
  const { t } = useTranslation('MistakesPage');
  const navigate = useNavigate();
  return (
    <PageLayout title={t('title')} onBack={() => void navigate(ROUTES.profile)}>
      <Card className="flex flex-col gap-5 border-none bg-transparent px-0 pb-5 pt-0 shadow-none">
        <TopicsTitleSkeleton />
        <OverviewSkeleton />
      </Card>
    </PageLayout>
  );
}

/**
 * Заголовок «Темы» на время загрузки — тоже шиммер: пока неизвестно, есть ли
 * ошибки, неизвестно и будет ли заголовок (без ошибок его нет, см.
 * `MistakesPage`). Настоящим текстом он мелькал и пропадал. Высота — строка
 * `text-xl` (28px).
 */
export function TopicsTitleSkeleton() {
  return <Skeleton className="h-7 w-20 rounded-lg" />;
}

export function OverviewSkeleton() {
  const { t } = useTranslation('MistakesPage');
  return (
    <div aria-busy="true" aria-live="polite" className="flex flex-col gap-4">
      <span className="sr-only">{t('loadingSr')}</span>
      <div className="flex flex-col gap-2">
        {[0, 1, 2].map((index) => (
          <TopicCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}

/** Высота — замер настоящей карточки без строки дельты, самый частый случай (см. `TopicCard`). */
function TopicCardSkeleton() {
  return <Skeleton className="h-[88px] rounded-2xl" />;
}
